import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { MobileSecurityCustomerViewController } from '../controller/MobileSecurityCustomerViewController';

export class MobileSecurityCustomerViewWebComponent extends BaseWebComponentElement {
  public controller: MobileSecurityCustomerViewController;

  constructor() {
    super();

    this.initialSetup({
      controllerConstructor: MobileSecurityCustomerViewController,
    });
  }
}
